import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Dialog, Button } from '@material-ui/core';
import {
  DeleteOutlined,
  CheckCircleRounded,
  ClearRounded,
  WarningRounded,
} from '@material-ui/icons';

export const useStyles = makeStyles((theme) => ({
  pageTitle: {
    fontWeight: '600',
    fontSize: theme.spacing(3.5),
    lineHeight: `${theme.spacing(5.25)}px`,
    fontFamily: 'Playfair Display, sans-serif !important',
  },
  dialog: {
    padding: theme.spacing(10),
    textAlign: 'center',
    '& svg': {
      width: theme.spacing(8),
      height: theme.spacing(8),
    },
  },
  singleButtonContainer: {
    '& button': {
      fontSize: theme.spacing(2.25),
      padding: theme.spacing(2),
      lineHeight: `${theme.spacing(3.5)}px`,
      textTransform: 'capitalize',
      marginTop: theme.spacing(2),

      [theme.breakpoints.up('sm')]: {
        marginTop: theme.spacing(5),
        padding: `${theme.spacing(2)}px ${theme.spacing(10)}px`,
      },
    },
  },
  gridButtonContainer: {
    textAlign: 'center',
    margin: 'auto',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridColumnGap: theme.spacing(4.5),
    maxWidth: theme.spacing(96.25),

    '& button': {
      maxWidth: theme.spacing(46.25),
      fontSize: theme.spacing(2.25),
      lineHeight: `${theme.spacing(3.5)}px`,
      cursor: 'pointer',
      padding: theme.spacing(2),
      textTransform: 'capitalize',
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(5),
    },
  },
}));
export const UserProfileDialog = (props) => {
  const { onClose, isOpen, type, onConfirm } = props;

  const classes = useStyles();

  const item = (() => {
    let logo, title, text, secondaryButton, primaryButton;
    if (type === 'delete') {
      logo = <DeleteOutlined color="primary" />;
      title = 'Are you sure you want to delete this item?';
      secondaryButton = 'Cancel';
      primaryButton = 'Yes';
    } else if (type === 'success') {
      logo = <CheckCircleRounded style={{ color: '#41BF06' }} />;
      title = 'Success!';
      text = 'You can check the changes you made';
      primaryButton = 'Back to My Account';
    } else if (type === 'error') {
      logo = (
        <ClearRounded
          style={{
            color: '#fff',
            backgroundColor: '#F4333D',
            borderRadius: '50%',
            borderWidth: '0px',
          }}
        />
      );
      title = 'Error Encountered';
      text = 'Please try again';
      secondaryButton = 'Try Again';
      primaryButton = 'Back to Edit';
    } else if (type === 'confirmSubmit') {
      logo = (
        <WarningRounded
          style={{
            color: '#F48120',
          }}
        />
      );
      title = 'Are you sure you want to make this changes?';
      secondaryButton = 'Cancel';
      primaryButton = 'Yes';
    } else if (type === 'passwordChanged') {
      logo = <CheckCircleRounded style={{ color: '#41BF06' }} />;
      title = 'Success!';
      text = 'You can check the changes you made';
      primaryButton = 'Login Now';
    }
    return { logo, title, text, secondaryButton, primaryButton };
  })();

  return (
    <Dialog onClose={onClose} open={isOpen}>
      <div className={classes.dialog}>
        {item.logo}
        <Typography component="h2" variant="subtitle1" className={classes.pageTitle}>
          {item.title}
        </Typography>
        {type !== 'delete' && (
          <Typography component="p" variant="subtitle1" className={classes.text}>
            {item.text}
          </Typography>
        )}
        <div
          className={
            type === 'success' || type === 'passwordChanged'
              ? classes.singleButtonContainer
              : classes.gridButtonContainer
          }
        >
          {type !== 'success' && type !== 'passwordChanged' && (
            <Button
              style={{ backgroundColor: '#fff', color: '#000', border: '1px solid #000' }}
              onClick={onClose}
              data-testid="on-close-button"
            >
              {item.secondaryButton}
            </Button>
          )}
          <Button
            style={{ backgroundColor: '#088CCA', color: '#fff' }}
            onClick={onConfirm}
            data-testid="on-confirm-button"
          >
            {item.primaryButton}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
UserProfileDialog.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  type: PropTypes.string,
  onConfirm: PropTypes.func,
};
